import React from "react"

import { ApiResponse } from "shared/types/ApiResponse"
import { WithClassName } from "shared/types/WithClassName"

import { TeamInvitation } from "entities/team-invitations/types/TeamInvitation"
import { TeamMember } from "entities/team-members/types/TeamMember"

import { useProjectTeamInvitationCardViewModel } from "./model/useProjectTeamInvitationCardViewModel"
import { ProjectTeamInvitationCardView } from "./ui/ProjectTeamInvitationCardView"

export interface ProjectTeamInvitationCardModel {
  teamInvitation: TeamInvitation

  onAccept?: (
    teamInvitation: TeamInvitation
  ) => void | Promise<ApiResponse<TeamMember>>
  isAccepting?: boolean

  onReject?: (
    teamInvitation: TeamInvitation
  ) => void | Promise<ApiResponse<unknown>>
  isRejecting?: boolean

  onNavigateToProject?: (id: string) => void
}

export interface ProjectTeamInvitationCardProps
  extends ProjectTeamInvitationCardModel,
    WithClassName {}

export const ProjectTeamInvitationCard = React.memo(
  (props: ProjectTeamInvitationCardProps) => {
    return (
      <ProjectTeamInvitationCardView
        {...useProjectTeamInvitationCardViewModel(props)}
      />
    )
  }
)
